export class AnswerGroupPos {

  public id: string;
  public onlyHeadConfirm: boolean;
  public positions: any[] = [];


  // Group ID here
  constructor(id: string, isOnlyHeadConfirm: boolean) {
    this.id = id;
    this.onlyHeadConfirm = isOnlyHeadConfirm;
  }

  addPos(pos: any) {
    this.positions.push(pos);
  }

  setIsOnlyHeadConfirm(f: boolean) {
    this.onlyHeadConfirm = f;
  }

  // addPosList(posList: any[]) {
  //   for (const pos of posList) {
  //     this.positions.push(pos);
  //   }
  // }

  // getId() {
  //   return this.id;
  // }

  // getPositions() {
  //   return this.positions;
  // }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/tree-group-pos-service/answer-group-pos.model.ts